import { render } from "./PanelAdminPeriodo.vue?vue&type=template&id=a033ad0a"
import script from "./PanelAdminPeriodo.vue?vue&type=script&lang=js"
export * from "./PanelAdminPeriodo.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__